import { render, staticRenderFns } from "./ReflectionForm.vue?vue&type=template&id=5e9a7326&scoped=true&"
import script from "./ReflectionForm.vue?vue&type=script&lang=js&"
export * from "./ReflectionForm.vue?vue&type=script&lang=js&"
import style0 from "./ReflectionForm.vue?vue&type=style&index=0&id=5e9a7326&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9a7326",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VSheet,VTextField,VTextarea})
